<template>
  <div>
    <el-form class="query-form elementui-common-form-styles" v-highlight label-width="50" inline>
      <el-form-item>
        <el-input
          v-model="queryForm.keyword"
          @keyup.enter.native="search"
          style="width: 240px"
          placeholder="账号名称/账号ID/草花账号ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="媒体">
        <el-select
          v-model="queryForm.mediaId"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新建人">
        <el-select
          v-model="queryForm.opId"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态">
        <el-select
          v-model="queryForm.status"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option
            v-for="item in [
              { name: '到账中', id: 0 },
              { name: '已到账', id: 1 },
              { name: '到账失败', id: 2 }
            ]"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新建时间">
        <DateRangePicker v-model="queryForm.daterange" style="width: 220px"></DateRangePicker>
      </el-form-item>

      <el-form-item class="bg-transparent">
        <el-button type="primary" @click="search" :loading="tableLoading">查询</el-button>
      </el-form-item>
    </el-form>

    <Viewport v-model="tableHeight">
      <el-table v-loading="tableLoading" class="common-el-table-styles" :height="tableHeight" :data="tableData" border ref="tableRef">
        <el-table-column
          v-for="prop in tableCols"
          :key="prop.key"
          :prop="prop.key"
          :label="prop.title"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.page.pageIndex"
          :page-size.sync="pager.page.pageSize"
          :total="pager.total"
          @current-change="getList"
          layout="prev, pager, next"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script>
import { rechargeCols, transferCols } from './data/log-cols.js'
import moment from 'moment'
import { getFinanceRechargeLog, getFinanceTransferLog } from '@/api/financial.model.js'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { initPageData, MEDIAS, PTOM_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MEDIAS, PTOM_USERS])

export default {
  name: 'finance-transfer-log',
  components: { DateRangePicker },

  data() {
    return {
      rechargeCols,
      tableHeight: 300,
      tableData: [],
      tableLoading: false,
      pager: {
        total: 0,
        page: {
          pageIndex: 1,
          pageSize: 20
        }
      },

      queryForm: {
        keyword: '',
        mediaId: '',
        opId: '',
        status: '',
        daterange: []
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    isTransfer() {
      return this.$route.path.includes('transfer')
    },
    isRecharge() {
      return this.$route.path.includes('recharge')
    },
    tableCols() {
      return this.isTransfer ? transferCols : rechargeCols
    }
  },
  created() {
    this.search()
  },

  methods: {
    search() {
      this.pager.page.pageIndex = 1
      this.getList()
    },
    getList() {
      const { daterange, ...restFormFileds } = this.queryForm
      const [beginTime, endTime] = this.queryForm.daterange || []
      const params = {
        ...restFormFileds,
        ...this.pager.page
      }
      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      this.tableLoading = true
      ;(this.$route.path.includes('transfer') ? getFinanceTransferLog : getFinanceRechargeLog)(params)
        .then((res) => {
          const { list, page_info } = res
          this.pager.total = page_info?.total_number || 0

          if (list?.length) {
            this.tableData = list.map((item) => {
              return {
                ...item,
                date: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
              }
            })
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
}
</style>
